import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [``],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: string = 'login';
    public loading: boolean = false;
    public notice: string = '';
    private returnTo: string = '/dashboard';

    public data: any = {
        email: '',
        password: ''
    };

    public async ngOnInit() {
        await this.service.init();

        const query = new URLSearchParams(location.search);
        this.returnTo = this.service.auth.safeReturnTo(query.get('returnTo'), '/dashboard');

        const reason = query.get('reason');
        if (reason === 'expired')
            this.notice = '로그인 세션이 만료되었습니다. 다시 로그인해주세요.';
        else if (reason === 'login-required')
            this.notice = '로그인이 필요한 서비스입니다. 로그인 후 계속할 수 있습니다.';

        if (this.service.auth.isLoggedIn()) {
            location.replace('/dashboard');
            return;
        }

        await this.service.render();
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async login() {
        if (this.loading)
            return;

        const user = JSON.parse(JSON.stringify(this.data));
        if (!user.email) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }

        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        this.loading = true;
        await this.service.render();

        try {
            const response: any = await wiz.call("login", user);

            if (response && response.code === 200) {
                location.replace(this.returnTo);
                return;
            }

            await this.alert(
                response && response.data && response.data.message
                    ? response.data.message
                    : "로그인에 실패했습니다.",
                'error'
            );
        } catch (e) {
            await this.alert("로그인 요청 중 오류가 발생했습니다.", 'error');
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }
}

export default PageAccessComponent;